import styled from "styled-components";

import { UserStatus } from "../../../types/users";

type UserStatusBoxProps = {
    status: UserStatus;
};

const UserStatusBox = ({ status }: UserStatusBoxProps): JSX.Element => {
    const content = () => {
        switch (status) {
            case UserStatus.ACTIVE:
                return <StyledActivated>Active</StyledActivated>;
            case UserStatus.INACTIVE:
                return <StyledDeactivated>Inactive</StyledDeactivated>;
            case UserStatus.PENDING:
            case UserStatus.PENDING_ACTIVATION:
                return <StyledPending>Pending Activation</StyledPending>;
            case UserStatus.PENDING_CREATE_APPROVAL:
                return <StyledPending>Pending Create Approval</StyledPending>;
            case UserStatus.PENDING_EDIT_APPROVAL:
                return <StyledPending>Pending Edit Approval</StyledPending>;
            case UserStatus.DRAFT:
                return <StyledPending>Draft</StyledPending>;
            default:
                return <></>;
        }
    };

    return content();
};

export const UserStatusText = (status : UserStatus): string => {
    switch (status) {
        case UserStatus.ACTIVE:
            return "Active";
        case UserStatus.INACTIVE:
            return "Inactive";
        case UserStatus.PENDING:
            return "Pending";
        case UserStatus.PENDING_CREATE_APPROVAL:
            return "Pending Create Approval";
        case UserStatus.PENDING_ACTIVATION:
            return "Pending Activation";
        case UserStatus.PENDING_EDIT_APPROVAL:
            return "Pending Edit Approval";
        case UserStatus.DRAFT:
            return "Draft";
        default:
            return "";
    }
};

const StyledDiv = styled.div`
    display: inline-block;
    padding: 3px 6px;
    border-radius: 0px;
    font-size: 12px;
`;

const StyledActivated = styled(StyledDiv)`
    background: #00847F;
    color: #ffffff;
`;
const StyledDeactivated = styled(StyledDiv)`
    background: #A8000B;
    color: #ffffff;
`;
const StyledPending = styled(StyledDiv)`
    background: #D7D8D6;
    color: #333333;
`;

export default UserStatusBox;
